<mat-toolbar class="footer">
  <span class="white-text">
    Copyright &copy; {{ anioActual }} Ministerio de Seguridad - Todos los derechos Reservados</span
  >
</mat-toolbar>
